<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Create Site Survey") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item md-xsmall-size-100 mx-auto">
      <simple-wizard @tab-change="onTabChange">
        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">{{ $t("Step 1: New Mission") }}</template>
          <first-step
            ref="step1"
            @on-validated="onStepOneValidated"
          ></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">{{ $t("Step 2: Map Editor") }}</template>
          <second-step
            ref="step2"
            @on-validated="onStepTwoValidated"
          ></second-step>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">{{ $t("Step 3: Calendar") }}</template>
          <third-step
            ref="step3"
            @on-validated="onStepThreeValidated"
          ></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">{{ $t("Step 4: Submission") }}</template>
          <fourth-step ref="step4" @on-validated="wizardComplete"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./NewSurveyWizard/FirstStep.vue";
import SecondStep from "./NewSurveyWizard/SecondStep.vue";
import ThirdStep from "./NewSurveyWizard/ThirdStep.vue";
import FourthStep from "./NewSurveyWizard/FourthStep.vue";
import { router } from "../../main";
import { USER_TYPE, AIR_STATUS } from "@/const.js";
import { mapFields } from "vuex-map-fields";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {},
      USER_TYPE: USER_TYPE
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    SimpleWizard,
    WizardTab
  },
  computed: {
    ...mapFields("survey", [
      "surveyDraft.controlled",
      "surveyDraft.air_status",
    ]),
    ...mapFields("auth", ["quantity", "plan_type", "usertype"])
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onTabChange(oldTab, newTab) {
      if (newTab.tabId === "2") {
        setTimeout(this.$refs["step3"].initCalendar, 40);
      }
    },
    onStepOneValidated(validated) {
      if (validated) {
        this.$store.dispatch("survey/saveSurveyDraftStepOne");
      }
    },
    onStepTwoValidated({
      validated,
      controlled,
      air_status,
      longitude,
      latitude,
      address,
      mapImageData,
      map_img
    }) {
      if (validated) {
        this.$store.dispatch("survey/saveSurveyDraftStepTwo", {
          controlled: controlled,
          longitude: longitude,
          latitude: latitude,
          address: address,
          mapImageData: mapImageData,
          map_img: map_img
        });

        if (controlled) {
          this.$store.dispatch("survey/getAirportIfApplicable");
        }
      }
    },
    onStepThreeValidated(validated, events) {
      if (validated) {
        this.$store.dispatch("survey/saveSurveyDraftStepThree", events);
      }
    },
    wizardComplete(validated) {
      if (validated) {
        this.$store.dispatch("survey/submitSurveyDraft");
        let title = "", desc = ""
        if (this.air_status && !(
            this.air_status === 'CONTROLLED' ||
            this.air_status === 'UNCONTROLLED'
        )) {
          let airStatusObj = AIR_STATUS[this.air_status] || {}
          title = this.$t(airStatusObj.title)
          desc = this.$t(airStatusObj.desc)
        } else if (this.controlled || this.air_status === 'CONTROLLED') {
          let airStatusObj = AIR_STATUS['CONTROLLED']
          title = this.$t(airStatusObj.title)
          desc = this.$t(airStatusObj.desc)
        }
        swal.fire({
          html: `
            <div>${this.$t('Site Survey is being generated.')}</div>
            <div style="font-size: 15px; margin-top: 16px;">
              <div>${title}</div>
              <div>${desc}</div>
            </div>
          `,
          type: "success",
          confirmButtonClass: "md-button md-success",
          buttonsStyling: false
        });

        router.push("/dashboard");
      }
    }
  },
  beforeMount() {
    if (this.usertype === USER_TYPE.FREE) {
      swal
        .fire({
          title: this.$t("Information"),
          text: this.$t(
            "Generating new site survey on web is accessible to Pro and Enterprise account. Please use RPAS WILCO app to create site survey."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
  },
  destroyed() {
    this.$store.commit("survey/setIsclone", false);
  }
};
</script>

<style lang="scss">
@media all and (max-width: 768px) {
  .md-list {
    display: block;
  }
}
</style>
